<button
  mat-stroked-button
  type="button"
  class="last-editor-button"
  [disabled]="!hasLogs"
  (click)="openLogDialog()"
>
  <ng-container *ngIf="hasLogs; else emptyLastEditor">
    {{ latestLog.initials }}&nbsp;&ndash;&nbsp;{{ latestLog.date | date: 'MM/dd/yyyy': 'PST' }}
  </ng-container>
  <ng-template #emptyLastEditor>LAST EDITOR</ng-template>
</button>
